import { render, staticRenderFns } from "./servecontent.vue?vue&type=template&id=6a6db3e8&"
import script from "./servecontent.vue?vue&type=script&lang=js&"
export * from "./servecontent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports